export default __webpack_public_path__ + "static/media/churrasqueira.e0240350.jpg";